import {Decimal} from 'decimal.js';

export default class DecimalUtils {
  static parseDecimal(
    value,
    nDecimals,
    defaultValue = 0,
    keepNullValue = false
  ) {
    try {
      if (
        value === Infinity ||
        value === -Infinity ||
        Number.isNaN(value) ||
        (value instanceof Decimal && (value.isNaN() || !value.isFinite()))
      ) {
        return new Decimal(NaN);
      } else if (!value) {
        if (keepNullValue && value === null) return null;
        return new Decimal(0);
      } else if (typeof value === 'string') {
        /**
         * If the value is a string, we need to convert it first into standard decimal format
         * - Replace grouping separators with empty string
         * - Replace decimal separator with dot -> Decimal.js lib only accepts dot as decimal separator
         */
        let valueToParse = value.replace(/[\s\u00A0\u202F]/g, '');
        const lastDotIndex = valueToParse.lastIndexOf('.');
        const lastCommaIndex = valueToParse.lastIndexOf(',');
        if (lastCommaIndex !== -1 || lastDotIndex !== -1) {
          const decimalSeparator =
            lastDotIndex > lastCommaIndex
              ? '.'
              : lastCommaIndex > lastDotIndex
              ? ','
              : null;
          const groupingSeparator =
            decimalSeparator === '.'
              ? ','
              : decimalSeparator === ','
              ? '.'
              : null;
          if (groupingSeparator) {
            valueToParse = valueToParse.replaceAll(groupingSeparator, '');
          }
          if (decimalSeparator === ',') {
            valueToParse = valueToParse.replace(',', '.');
          }
        }
        return new Decimal(valueToParse).toDecimalPlaces(nDecimals);
      }
      return new Decimal(value).toDecimalPlaces(nDecimals);
    } catch (e) {
      console.error('Error while converting to decimal', e);
      return new Decimal(defaultValue).toDecimalPlaces(nDecimals);
    }
  }
}
